import { article } from '@stereoagency/sanity-schema';

const orderedBuilder = article.schema.builder.orderBy(
  'datetime',
  'desc'
) as typeof article.schema.builder;

export const newsQuery = orderedBuilder
  .pick(['slug', 'title', 'introduction', 'thumbnail'])
  .select(0, 3, true)
  .use();
